import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import NewsletterSection from "@/pages/home/components/NewsletterSection";
import NewsSubmissionCTA from "@/components/feature/NewsSubmissionCTA";
import SEO from "@/components/SEO";

const airports = [
  { name: "Las Américas (SDQ)", pax: "4.8M", growth: "+7.2%", ops: "42K", cargo: "28K ton", city: "Santo Domingo", type: "Internacional" },
  { name: "Punta Cana (PUJ)", pax: "9.1M", growth: "+9.1%", ops: "68K", cargo: "12K ton", city: "Punta Cana", type: "Internacional" },
  { name: "El Catey (AZS)", pax: "1.2M", growth: "+15.3%", ops: "8.5K", cargo: "1.2K ton", city: "Samaná", type: "Internacional" },
  { name: "Cibao (STI)", pax: "2.1M", growth: "+6.8%", ops: "18K", cargo: "3.8K ton", city: "Santiago", type: "Internacional" },
  { name: "Gregorio Luperón (POP)", pax: "1.8M", growth: "+5.4%", ops: "14K", cargo: "2.1K ton", city: "Puerto Plata", type: "Internacional" },
  { name: "La Romana (LRM)", pax: "420K", growth: "+3.2%", ops: "3.2K", cargo: "850 ton", city: "La Romana", type: "Internacional" },
  { name: "La Isabela (JBQ)", pax: "85K", growth: "+12.1%", ops: "12K", cargo: "0", city: "Santo Domingo", type: "Aviación General" },
  { name: "María Montez (BRX)", pax: "45K", growth: "+8.7%", ops: "2.1K", cargo: "120 ton", city: "Barahona", type: "Internacional" },
];

const hourlyTraffic = [
  { hour: "00-04", value: 4 },
  { hour: "04-06", value: 8 },
  { hour: "06-08", value: 18 },
  { hour: "08-10", value: 22 },
  { hour: "10-12", value: 20 },
  { hour: "12-14", value: 16 },
  { hour: "14-16", value: 18 },
  { hour: "16-18", value: 19 },
  { hour: "18-20", value: 15 },
  { hour: "20-22", value: 10 },
  { hour: "22-24", value: 6 },
];
const maxHourly = Math.max(...hourlyTraffic.map((d) => d.value));

const infrastructureInvestments = [
  { airport: "Las Américas", project: "Terminal B Renovación", cost: "RD$2,000M", status: "En construcción", completion: "2027" },
  { airport: "Punta Cana", project: "Nueva terminal norte", cost: "RD$3,500M", status: "Planificado", completion: "2028" },
  { airport: "Pedernales", project: "Nuevo aeropuerto internacional", cost: "RD$1,800M", status: "En construcción", completion: "2027" },
  { airport: "El Catey", project: "Ampliación de pista", cost: "RD$650M", status: "En construcción", completion: "2026" },
  { airport: "Cibao", project: "Nueva torre de control", cost: "RD$420M", status: "Completado", completion: "2025" },
];

const paxByAirportData = [
  { airport: "PUJ", value: 9.1, label: "9.1M" },
  { airport: "SDQ", value: 4.8, label: "4.8M" },
  { airport: "STI", value: 2.1, label: "2.1M" },
  { airport: "POP", value: 1.8, label: "1.8M" },
  { airport: "AZS", value: 1.2, label: "1.2M" },
  { airport: "LRM", value: 0.4, label: "420K" },
  { airport: "BRX", value: 0.05, label: "45K" },
];
const maxAirportPax = Math.max(...paxByAirportData.map((d) => d.value));

export default function EstadisticasAeropuertos() {
  return (
    <main className="min-h-screen bg-[#071529]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
      <SEO
        jsonLdSchemas={[
          {
            "@type": "WebPage",
            name: "Estadísticas de Aeropuertos",
            description: "Tráfico, operaciones, inversión e infraestructura de los aeropuertos dominicanos.",
            url: 'https://aviacioninsightrd.com/estadisticas-aeropuertos',
          },
        ]}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: "linear-gradient(#6366f1 1px, transparent 1px), linear-gradient(90deg, #6366f1 1px, transparent 1px)", backgroundSize: "48px 48px" }} />
        <div className="max-w-screen-xl mx-auto px-4 md:px-6 relative z-10">
          <div className="flex items-center gap-2 mb-4">
            <Link to="/aeropuertos" className="text-indigo-400 text-sm hover:text-indigo-300 cursor-pointer">Aeropuertos</Link>
            <i className="ri-arrow-right-s-line text-indigo-600" />
            <span className="text-slate-400 text-sm">Estadísticas</span>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
            <div>
              <div className="flex items-center gap-2 bg-indigo-600/20 border border-indigo-500/30 rounded-full px-3 py-1 w-fit mb-3">
                <span className="w-2 h-2 bg-indigo-400 rounded-full animate-pulse" />
                <span className="text-indigo-300 text-[10px] font-bold tracking-widest uppercase">Datos JAC · AERODOM · IDAC · Actualizado abr. 2026</span>
              </div>
              <h1 className="text-white font-bold" style={{ fontFamily: "'Sora', sans-serif", fontSize: "clamp(2rem, 5vw, 3rem)" }}>
                ESTADÍSTICAS DE AEROPUERTOS
              </h1>
              <p className="text-indigo-200/60 text-sm mt-2">Tráfico, operaciones, inversión e infraestructura de los aeropuertos dominicanos</p>
            </div>
            <Link
              to="/aeropuertos"
              className="flex-shrink-0 flex items-center gap-2 px-5 py-3 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold text-sm rounded-lg transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              Volver a Aeropuertos
            </Link>
          </div>
        </div>
      </section>

      {/* Airport pax chart + hourly */}
      <section className="pb-10">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Passengers by airport */}
            <div className="lg:col-span-2 bg-white/5 border border-white/8 rounded-xl p-6">
              <h3 className="text-white font-bold mb-1" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.1rem" }}>
                PASAJEROS POR AEROPUERTO 2025
              </h3>
              <p className="text-slate-500 text-xs mb-5">Millones de pasajeros por terminal · Tráfico internacional + doméstico</p>
              <div className="flex items-end gap-3 h-40">
                {paxByAirportData.map((d) => {
                  const height = Math.round((d.value / maxAirportPax) * 100);
                  return (
                    <div key={d.airport} className="flex-1 flex flex-col items-center gap-2 group">
                      <div className="w-full relative flex items-end" style={{ height: "130px" }}>
                        <div className="absolute bottom-0 left-0 right-0 w-full rounded-t-md bg-indigo-600 transition-all duration-300 group-hover:brightness-125" style={{ height: `${height}%` }} />
                        <div className="absolute -top-6 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity bg-indigo-600 text-white text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap">
                          {d.label}
                        </div>
                      </div>
                      <span className="text-slate-400 text-[10px]">{d.airport}</span>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Hourly traffic */}
            <div className="bg-white/5 border border-white/8 rounded-xl p-6">
              <h3 className="text-white font-bold mb-1" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.1rem" }}>
                TRÁFICO POR HORA (SDQ)
              </h3>
              <p className="text-slate-500 text-xs mb-5">Porcentaje de operaciones por franja horaria</p>
              <div className="space-y-3">
                {hourlyTraffic.map((d) => {
                  const width = Math.round((d.value / maxHourly) * 100);
                  return (
                    <div key={d.hour} className="flex items-center gap-3">
                      <span className="text-slate-400 text-[10px] w-12 text-right">{d.hour}h</span>
                      <div className="flex-1 h-2 bg-white/10 rounded-full overflow-hidden">
                        <div className="h-full rounded-full bg-indigo-500" style={{ width: `${width}%` }} />
                      </div>
                      <span className="text-slate-400 text-[10px] w-8">{d.value}%</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Airport details + investments */}
      <section className="pb-10">
        <div className="max-w-screen-xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Airport details table */}
            <div className="lg:col-span-2 bg-white/5 border border-white/8 rounded-xl p-6">
              <h3 className="text-white font-bold mb-1" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.1rem" }}>
                DETALLE POR AEROPUERTO 2025
              </h3>
              <p className="text-slate-500 text-xs mb-5">Pasajeros, operaciones y carga por terminal</p>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-white/10">
                      {["Aeropuerto", "Ciudad", "Pasajeros", "Crecimiento", "Ops.", "Carga"].map((h, i) => (
                        <th key={h} className={`text-slate-400 text-xs pb-3 font-semibold ${i >= 2 ? "text-right" : "text-left"}`}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {airports.map((r, i) => (
                      <tr key={r.name} className={`border-b border-white/5 hover:bg-white/5 transition-colors ${i === 0 ? "bg-indigo-600/10" : ""}`}>
                        <td className="py-3">
                          <div>
                            <span className="text-white font-bold text-sm" style={{ fontFamily: "'Sora', sans-serif" }}>{r.name}</span>
                            <span className="text-slate-500 text-[10px] block">{r.type}</span>
                          </div>
                        </td>
                        <td className="py-3 text-slate-400 text-xs">{r.city}</td>
                        <td className="py-3 text-right text-white font-semibold text-sm">{r.pax}</td>
                        <td className="py-3 text-right">
                          <span className="text-emerald-400 text-xs font-semibold">{r.growth}</span>
                        </td>
                        <td className="py-3 text-right text-slate-300 text-xs">{r.ops}</td>
                        <td className="py-3 text-right text-slate-300 text-xs">{r.cargo}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Infrastructure investments */}
            <div className="bg-white/5 border border-white/8 rounded-xl p-6">
              <h3 className="text-white font-bold mb-5" style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: "1.1rem" }}>
                INVERSIÓN EN INFRAESTRUCTURA
              </h3>
              <div className="space-y-4">
                {infrastructureInvestments.map((inv) => (
                  <div key={inv.project} className="py-3 border-b border-white/5">
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-white text-xs font-semibold">{inv.project}</span>
                      <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${
                        inv.status === "Completado" ? "bg-emerald-500/20 text-emerald-400" :
                        inv.status === "En construcción" ? "bg-amber-500/20 text-amber-400" :
                        "bg-blue-500/20 text-blue-400"
                      }`}>
                        {inv.status}
                      </span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-slate-400 text-[10px]">{inv.airport} · {inv.cost}</span>
                      <span className="text-slate-500 text-[10px]">{inv.completion}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Source */}
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 pb-10">
        <p className="text-slate-600 text-xs">
          <i className="ri-information-line mr-1" />
          Fuente: <strong className="text-slate-500">Junta de Aviación Civil (JAC)</strong>, <strong className="text-slate-500">AERODOM</strong>, <strong className="text-slate-500">IDAC</strong> · Datos actualizados al 30 de abril de 2026.
        </p>
      </div>

      <div className="max-w-screen-xl mx-auto px-4 md:px-6 pb-8">
        <NewsSubmissionCTA
          variant="light"
          title="¿Tienes datos de aeropuertos?"
          description="Si trabajas en un aeropuerto o entidad operadora y tienes estadísticas o reportes, compártelos con nuestra audiencia."
        />
      </div>

      <NewsletterSection />
      <Footer />
    </main>
  );
}